﻿import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormTextInput, FormGroupedCheckboxItems, FormHelperText } from 'components/form-fields';
import { ShowHide } from "components/layout";
import { TagList } from 'components/status';
import { HelperFunctions } from 'helpers';
import _ from 'underscore';
import 'components/form-fields/FormFields.css';

export function FormGroupedCheckboxList(
    {
        searchable = false,
        showTags = false,
        groupsSelectable = false,
        onGroupSelect = () => { },
        onSearch = () => { },
        loading = false,
        saving = false,
        dangerHelperText = null,
        filter = null,
        itemIcon = null,
        onTagRemove = null,
        disabled = false,
        headingText,
        items,
        onGroupToggle,
        onItemSelect
    }
) {

    const [searchTerm, setSearchTerm] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(initialLoad, [items]);

    function initialLoad() {

        setSelectedItems(_.chain(items).pluck('items').flatten().where({ checked: true }).uniq(function (i) {
            return i.id;
        }).value());

    }

    function onRemoveItem(event, id) {
        HelperFunctions.executeIfNotNull(onTagRemove, id);
    }

    function onSearchChange(item) {

        var newSearchTerm = item.target.value;

        setSearchTerm(newSearchTerm);
        onSearch(newSearchTerm);
    }

    return (
        <div className="form-field form-field-grouped-checkboxes">
            <ShowHide
                evaluator={headingText != null}
                show={(
                    <h4 className={classNames({ "bp6-skeleton": loading })}>{headingText}</h4>
                )}
            />
            <ShowHide
                evaluator={showTags}
                show={(
                    <TagList items={selectedItems} disabled={saving || disabled} onRemoveTag={onRemoveItem} />
                )}
            />
            <ShowHide
                evaluator={searchable}
                show={(
                    <div className="chechbox-list-search">
                        <FormTextInput placeholder="Search" onChange={onSearchChange} value={searchTerm} large disabled={saving || disabled} icon="search" loading={loading} />
                    </div>
                )}
            />
            <div className={classNames("grouped-checkbox-list-container", { "bp6-skeleton": loading })}>
                <div className="grouped-checkbox-list-scroll">
                    <FormGroupedCheckboxItems items={items} searchTerm={searchTerm} groupsSelectable={groupsSelectable} onGroupToggle={onGroupToggle} onItemSelect={onItemSelect} onGroupSelect={onGroupSelect} loading={loading} filter={filter} itemIcon={itemIcon} disabled={saving || disabled} />
                </div>
            </div>
            <FormHelperText loading={loading} danger={true}>{dangerHelperText}</FormHelperText>
        </div>
    );
}

FormGroupedCheckboxList.propTypes = {
    items: PropTypes.array.isRequired,
    searchable: PropTypes.bool,
    showTags: PropTypes.bool,
    groupsSelectable: PropTypes.bool,
    onGroupToggle: PropTypes.func.isRequired,
    onItemSelect: PropTypes.func.isRequired,
    onGroupSelect: PropTypes.func,
    onSearch: PropTypes.func,
    loading: PropTypes.bool,
    saving: PropTypes.bool,
    dangerHelperText: PropTypes.node,
    filter: PropTypes.func,
    itemIcon: PropTypes.string,
    onTagRemove: PropTypes.func,
    disabled: PropTypes.bool,
    headingText: PropTypes.string
};
